import React from "react";
import { COMPANY, NAV_LINKS } from "@/data/site";
import Logo from "@/components/Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      style={{ background: "var(--ink)", borderTop: "1px solid var(--line)", paddingTop: 48, paddingBottom: 32 }}
    >
      <div className="site-container">
        <div
          className="ft-grid"
          style={{ display: "grid", gridTemplateColumns: "1fr", gap: 28 }}
        >
          <style>{`
            @media (min-width: 768px) {
              .ft-grid { grid-template-columns: 1.4fr 1fr 1fr !important; gap: 56px !important; }
            }
          `}</style>

          <div>
            <div style={{ marginBottom: 12 }}>
              <Logo height={56} />
            </div>
            <p className="small" style={{ marginTop: 6, color: "var(--text-mid)", lineHeight: 1.7, maxWidth: 320 }}>
              Tetőfedés, lemezfedés, tetőszerkezet és felújítás. {COMPANY.serviceArea}.
            </p>
          </div>

          <div>
            <span className="eyebrow-muted">Navigáció</span>
            <nav style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 14 }}>
              {NAV_LINKS.map((l) => (
                <a
                  key={l.label} href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  style={{ fontSize: 13, color: "var(--text-mid)", textDecoration: "none" }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "var(--gold)")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "var(--text-mid)")}
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <span className="eyebrow-muted">Elérhetőség</span>
            <div style={{ marginTop: 14, fontSize: 13, color: "var(--text-mid)", lineHeight: 1.85 }}>
              <a href={COMPANY.phoneHref} style={{ color: "var(--text)", textDecoration: "none", display: "block" }}>
                {COMPANY.phoneDisplay}
              </a>
              <a href={`mailto:${COMPANY.email}`} style={{ color: "var(--text-mid)", textDecoration: "none", display: "block" }}>
                {COMPANY.email}
              </a>
              <span style={{ color: "var(--text-dim)", display: "block", marginTop: 6 }}>
                Magyarország
              </span>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 40, paddingTop: 20, borderTop: "1px solid var(--line)", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 12, fontSize: 11, color: "var(--text-dim)", letterSpacing: "0.04em" }}>
          <span>© {year} {COMPANY.name}</span>
          <span>Cégadatok — egyeztetni kell</span>
        </div>
      </div>
    </footer>
  );
}
